import {
  Alert,
  Box,
  Button,
  Grid,
  Icon,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from "@mui/material";
import { Link } from "react-router-dom";
import { buildQuery } from "../../api/ESocialJTServiceApi";
import {
  competenciaExibicao,
  moeda,
  numero,
  TIPOS
} from "../../shared/apresentacaoEvento";
import { Abas } from "./Elementos";

export default function ValoresDashboard({ dashboard, filtros }) {
  const tipos = dashboard.financeiroPorTipo || [];
  const competencias = dashboard.financeiroPorCompetencia || [];
  if (!tipos.length) return null;
  const valor = (r, campo) =>
    Number(r.itens) ? moeda(r[campo]) : "Não informado";
  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="h6" fontWeight={600} sx={{ mb: 0.5 }}>
        Valores das ocorrências
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Valores declarados neste recorte, separados por evento e situação de
        processamento.
      </Typography>
      <Abas
        label="Valores do dashboard"
        secoes={[
          {
            id: "valores-evento",
            label: "Por evento",
            icon: "payments",
            content: (
              <Grid container spacing={2}>
                {tipos.map((r) => (
                  <Grid key={r.tipo} item xs={12} md={6}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2.5, borderRadius: 2, height: "100%" }}
                    >
                      <Typography variant="subtitle2">
                        S-{r.tipo} · {TIPOS[r.tipo]}
                      </Typography>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ mt: 1 }}
                      >
                        {r.natureza === "PAGAMENTOS"
                          ? "Pagamentos líquidos informados"
                          : "Valores informados nas rubricas"}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: { xs: 25, md: 30 },
                          fontWeight: 700,
                          my: 1,
                          overflowWrap: "anywhere"
                        }}
                      >
                        {valor(r, "valor")}
                      </Typography>
                      <Stack spacing={0.7} sx={{ mb: 2 }}>
                        {[
                          ["Com sucesso", "sucesso", "success.main"],
                          ["Com erro", "erros", "error.main"],
                          ["Aguardando", "aguardando", "text.secondary"]
                        ].map(([label, campo, color]) => (
                          <Stack
                            key={campo}
                            direction="row"
                            justifyContent="space-between"
                            gap={1}
                          >
                            <Typography variant="body2" color={color}>
                              {label}
                            </Typography>
                            <Typography variant="body2" fontWeight={500}>
                              {valor(r, campo)}
                            </Typography>
                          </Stack>
                        ))}
                      </Stack>
                      <Typography
                        variant="caption"
                        display="block"
                        color="text.secondary"
                      >
                        {numero(r.ocorrencias)} ocorrências · {numero(r.itens)}{" "}
                        valores · {numero(r.retificacoes)} retificações
                      </Typography>
                      {Number(r.invalidos) > 0 && (
                        <Alert severity="warning" sx={{ mt: 1 }}>
                          {numero(r.invalidos)} valores inválidos não
                          participaram da soma.
                        </Alert>
                      )}
                      <Button
                        component={Link}
                        to={buildQuery("/", { ...filtros, tipos: r.tipo })}
                        size="small"
                        endIcon={<Icon>arrow_forward</Icon>}
                        sx={{ mt: 1 }}
                      >
                        Consultar ocorrências
                      </Button>
                    </Paper>
                  </Grid>
                ))}
              </Grid>
            )
          },
          {
            id: "valores-competencia",
            label: "Por competência",
            icon: "calendar_month",
            content: (
              <TableContainer>
                <Table size="small" aria-label="Valores por competência">
                  <TableHead>
                    <TableRow>
                      <TableCell>Competência / evento</TableCell>
                      <TableCell align="right">Declarado</TableCell>
                      <TableCell align="right">Com sucesso</TableCell>
                      <TableCell align="right">Com erro</TableCell>
                      <TableCell align="right">Aguardando</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {competencias.map((r, i) => (
                      <TableRow key={i}>
                        <TableCell>
                          {competenciaExibicao(r.competencia)}
                          <Typography variant="caption" display="block">
                            S-{r.tipo} · {TIPOS[r.tipo]}
                          </Typography>
                        </TableCell>
                        {["valor", "sucesso", "erros", "aguardando"].map(
                          (campo) => (
                            <TableCell
                              key={campo}
                              align="right"
                              sx={{ whiteSpace: "nowrap" }}
                            >
                              {valor(r, campo)}
                            </TableCell>
                          )
                        )}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )
          }
        ]}
      />
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1.5 }}>
        Rubricas incluem parcelas de diferentes naturezas; sua soma não
        representa remuneração bruta ou líquida. Os pagamentos S-1210 são
        apresentados separadamente. Retificações são contadas como novas
        ocorrências; estes valores não substituem os totalizadores do eSocial
        nem consolidam a folha vigente.
      </Typography>
    </Box>
  );
}
